<template>
  <IframeCmp type="124" />
</template>

<script>
import IframeCmp from './cmp/IframeCmp';

export default {
  // 揽收已签收报表明细
  name: 'CollectionSignedReportDetails',
  components: {
    IframeCmp
  },
  data() {
    return {

    };
  }
};
</script>
